import { createAction, props } from '@ngrx/store';

import { Notification } from '../models/notification.model';

import {
	FETCH_NOTIFICATIONS_FAILURE,
	FETCH_NOTIFICATIONS_START,
	FETCH_NOTIFICATIONS_SUCCESS,
	UPDATE_NOTIFICATION_STATUS_SUCCESS,
	FETCH_NOTIFICATIONS_COUNT_START,
	FETCH_NOTIFICATIONS_COUNT_SUCCESS,
	FETCH_NOTIFICATIONS_COUNT_FAILURE,
} from './notifications.selector';

export const fetchNotificationsCountStart = createAction(
	FETCH_NOTIFICATIONS_COUNT_START,
);
export const fetchNotificationsCountSuccess = createAction(
	FETCH_NOTIFICATIONS_COUNT_SUCCESS,
	props<{ count: number }>(),
);
export const fetchNotificationsCountFailure = createAction(
	FETCH_NOTIFICATIONS_COUNT_FAILURE,
);

export const fetchNotificationsStart = createAction(
	FETCH_NOTIFICATIONS_START,
	props<{ orgId?: string }>(),
);
export const fetchNotificationsSuccess = createAction(
	FETCH_NOTIFICATIONS_SUCCESS,
	props<{ notifications: Notification[] }>(),
);
export const fetchNotificationsFailure = createAction(
	FETCH_NOTIFICATIONS_FAILURE,
);

export const updateNotificationStatusSuccess = createAction(
	UPDATE_NOTIFICATION_STATUS_SUCCESS,
	props<{ update: number }>(),
);
